import { render, staticRenderFns } from "./ByPaymentMethod.vue?vue&type=template&id=20edd39b&"
import script from "./ByPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ByPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports